// extracted by mini-css-extract-plugin
export default {"LeftPanel__spinner":"LeftPanel_LeftPanel__spinner__1AIo8","spin":"LeftPanel_spin__3FTkF"};